import { cn } from '@/lib/cn';

type CitationBadgeProps = {
  selected: boolean;
  children: React.ReactNode;
  onClick: React.MouseEventHandler<HTMLSpanElement>;
};

export const CitationBadge = (props: CitationBadgeProps) => {
  return (
    <span
      onClick={props.onClick}
      className={cn(
        ' text-[0.875em] inline-flex items-center ml-[0.125em] -translate-y-[0.0625em] h-[1.25em] min-w-[1.25em] px-[0.375em] rounded-full bg-gray-300 text-gray-800 transition-all duration-200 hover:bg-gray-400 cursor-pointer justify-center font-medium',
        props.selected && 'bg-gray-800 text-white hover:bg-gray-900',
      )}
    >
      <span className="text-[0.875em] font-semibold">{props.children}</span>
    </span>
  );
};
